import { booleanAttribute, Component, input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmErrorDirective, HlmFormFieldComponent } from '@spartan-ng/ui-formfield-helm';
import { HlmInputDirective } from '@spartan-ng/ui-input-helm';
import { HlmLabelDirective } from '@spartan-ng/ui-label-helm';
import { NgxControlError } from 'ngxtension/control-error';

@Component({
    selector: 'sona-set-password-form',
    template: `
        <hlm-form-field class="tw-w-full">
            <label hlmLabel class="tw-w-full">
                {{ 'AUTH.UI_COMPONENTS.SET_PASSWORD_FORM.PASSWORD.LABEL' | translate }}
                <input
                    hlmInput
                    class="tw-w-full"
                    type="password"
                    autocomplete="new-password"
                    [formControl]="passwordControl()"
                />
            </label>
            <hlm-error
                *ngxControlError="passwordControl()!; track: 'required'">{{ 'AUTH.UI_COMPONENTS.SET_PASSWORD_FORM.PASSWORD.ERROR.REQUIRED' | translate }}
            </hlm-error>
            <hlm-error
                *ngxControlError="passwordControl()!; track: 'minlength'">{{ 'AUTH.UI_COMPONENTS.SET_PASSWORD_FORM.PASSWORD.ERROR.MIN_LENGTH' | translate }}
            </hlm-error>
            <hlm-error
                *ngxControlError="passwordControl()!; track: 'uppercase'">{{ 'AUTH.UI_COMPONENTS.SET_PASSWORD_FORM.PASSWORD.ERROR.UPPERCASE' | translate }}
            </hlm-error>
            <hlm-error
                *ngxControlError="passwordControl()!; track: 'lowercase'">{{ 'AUTH.UI_COMPONENTS.SET_PASSWORD_FORM.PASSWORD.ERROR.LOWERCASE' | translate }}
            </hlm-error>
            <hlm-error
                *ngxControlError="passwordControl()!; track: 'number'">{{ 'AUTH.UI_COMPONENTS.SET_PASSWORD_FORM.PASSWORD.ERROR.NUMBER' | translate }}
            </hlm-error>
            <hlm-error
                *ngxControlError="passwordControl()!; track: 'specialCharacter'">{{ 'AUTH.UI_COMPONENTS.SET_PASSWORD_FORM.PASSWORD.ERROR.SPECIAL_CHARACTER' | translate }}
            </hlm-error>
        </hlm-form-field>
        <p class="tw-text-muted-foreground tw-text-xs tw-mt-2 tw-mb-4 tw-mx-0.5">
            {{ 'AUTH.UI_COMPONENTS.SET_PASSWORD_FORM.PASSWORD.DESCRIPTION' | translate }}
        </p>

        <hlm-form-field class="tw-w-full tw-mb-6">
            <label hlmLabel class="tw-w-full">
                {{ 'AUTH.UI_COMPONENTS.SET_PASSWORD_FORM.CONFIRM_PASSWORD.LABEL' | translate }}
                <input
                    hlmInput
                    class="tw-w-full"
                    type="password"
                    autocomplete="new-password"
                    [formControl]="confirmPasswordControl()"
                />
            </label>

            <hlm-error
                *ngxControlError="confirmPasswordControl()!; track: 'required'">{{ 'AUTH.UI_COMPONENTS.SET_PASSWORD_FORM.CONFIRM_PASSWORD.ERROR.REQUIRED' | translate }}
            </hlm-error>
            <hlm-error
                *ngxControlError="confirmPasswordControl()!; track: 'passwordMatch'">{{ 'AUTH.UI_COMPONENTS.SET_PASSWORD_FORM.CONFIRM_PASSWORD.ERROR.PASSWORD_MISMATCH' | translate }}
            </hlm-error>
        </hlm-form-field>
    `,
    imports: [
        HlmFormFieldComponent,
        HlmLabelDirective,
        TranslatePipe,
        HlmInputDirective,
        FormsModule,
        ReactiveFormsModule,
        NgxControlError,
        HlmErrorDirective
    ]
})
export class PasswordFormComponent {

    readonly passwordControl = input.required<FormControl>();
    readonly confirmPasswordControl = input.required<FormControl>();

    readonly disabled = input(false, { transform: booleanAttribute });
}